<template>
  <v-snackbar app :color="color" :value="value" :timeout="timeout" @input="$emit('input', $event)" top>
    <v-row class="justify-space-between">
      <div class="ml-4" style="margin-top: 7px">{{ msg }}</div>
      <v-btn @click="clearStoreSnack" color="white" text>Close</v-btn>
    </v-row>
  </v-snackbar>
</template>

<script>
export default {
  name: "Snack",
  props: {
    color: {
      type: String,
      default: 'secondary'
    },
    msg: {
      required: true,
      default: 'Success'
    },
    timeout: {// 31 Dec 2025 JCH allow timeout to be customized
      type: Number,
      default: 6000
    },
    value: Boolean
  },

  watch: {
    value() {
      if (!this.value) this.clearStoreSnack();
    }
  },

  methods: {
    clearStoreSnack() {
      this.$store.dispatch('SET_SNACK', { cmpnt: '', open: false, color: 'transparent', msg: ''});
    },
  },
}
</script>

<style scoped>

</style>
